import { Button } from "primereact/button";
import { Column, ColumnEditorOptions } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { options } from "jodit/esm/core/helpers";

interface IPOC_Setting {
    id?: number,
    last_Req_Days?: number,
    last_ECS_Days?: number,
    last_ECI_Days?: number,
    last_PO_Days?: number,
    blacklist_Company_Request_Count?: number,
    updated_By?: string,
    updated_At?: Date,
}

interface IProps {
    reload: boolean,
    setReload: (reload: boolean) => void,
    toast: any,
}

export const InActivePOCSetting = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IPOC_Setting>, loading: boolean });
    const [loading, setLoading] = useState<boolean>(false);
    const [focusIndex, setFocusIndex] = useState<number>(-1);
    const dt = useRef<any>(null);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("lead-capture/leadCpaturedPOCEmailSetting", "GET", null, null, props.toast);
        if (response) {
            const data: Array<IPOC_Setting> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    };

    const onsubmit = async () => {
        setLoading(true);
        let isError1: number = 0;
        let isErrorIndex: number = 0;

        const newData: any = tableData.tableData.map((el: IPOC_Setting, index: number) => {

            return {
                id: el.id,
                last_Req_Days: el.last_Req_Days,
                last_ECS_Days: el.last_ECS_Days,
                last_ECI_Days: el.last_ECI_Days,
                last_PO_Days: el.last_PO_Days,
                blacklist_Company_Request_Count: el.blacklist_Company_Request_Count
            };
        });


        const method = "PUT";
        const message = "Updated Successfully";
        setLoading(true);

        const resp = await Fetch("lead-capture/updateLeadCpaturedPOCEmailSetting", method, newData, null, null);
        if (resp) {
            props.toast.current.show({ severity: "success", detail: message, life: 3000, });
            props.setReload(!props.reload);
            setLoading(false);
            setFocusIndex(-1);
        } else setLoading(false);
    }

    const isPositiveInteger = (val: any) => {
        let str = String(val);

        str = str.trim();

        if (!str) {
            return false;
        }

        str = str.replace(/^0+/, '') || '0';
        let n = Math.floor(Number(str));

        return n !== Infinity && String(n) === str && n >= 0;
    };

    const onCellEditComplete = async (e: any) => {
        let { rowData, newValue, field, originalEvent: event } = e;

        switch (field) {
            case 'last_Req_Days':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            case 'last_ECS_Days':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            case 'last_ECI_Days':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            case 'last_PO_Days':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            case 'blacklist_Company_Request_Count':
                if (isPositiveInteger(newValue)) rowData[field] = newValue;
                else event.preventDefault();
                break;

            default:
                if (newValue.trim().length > 0) rowData[field] = newValue;
                else event.preventDefault();
                break;
        };


        setTableData(prev => {
            const updatedData = prev.tableData.map((item: IPOC_Setting, index: any) => {
                if (index === focusIndex) {
                    setFocusIndex(-1);
                }
                if (item.id === rowData.id) {
                    return {
                        ...item,
                        last_Req_Days: isPositiveInteger(rowData.last_Req_Days) ? Number(rowData.last_Req_Days) : item.last_Req_Days,
                        last_ECS_Days: isPositiveInteger(rowData.last_ECS_Days) ? Number(rowData.last_ECS_Days) : item.last_ECS_Days,
                        last_ECI_Days: isPositiveInteger(rowData.last_ECI_Days) ? Number(rowData.last_ECI_Days) : item.last_ECI_Days,
                        last_PO_Days: isPositiveInteger(rowData.last_PO_Days) ? Number(rowData.last_PO_Days) : item.last_PO_Days,
                        blacklist_Company_Request_Count: isPositiveInteger(rowData.blacklist_Company_Request_Count) ? Number(rowData.blacklist_Company_Request_Count) : item.blacklist_Company_Request_Count
                    };
                }
                return item;
            });
            return { ...prev, tableData: updatedData };
        })
    };

    const cellEditor = (options: ColumnEditorOptions) => {
        const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
            if (options.editorCallback) {
                options.editorCallback(e.target.value);
            }
        };
        return <input style={{ width: '100%', margin: 0, padding: '3px 5px', border: '2px solid green', cursor: "pointer" }} value={options.value} type='number' onChange={(e) => handleChange(e)} />
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload]);

    return (
        <>
            <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0", }}
                size="small" ref={dt} value={tableData.tableData} emptyMessage="No Data found."
                loading={tableData.loading} showGridlines stripedRows responsiveLayout="scroll"
            >
                <Column field="blacklist_Company_Request_Count" header="Blacklist Company On Request Count" body={(rowData: IPOC_Setting) => <p>{rowData.blacklist_Company_Request_Count}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column field="last_Req_Days" header="Last Req Days" body={(rowData: IPOC_Setting) => <p>{rowData.last_Req_Days}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column field="last_ECS_Days" header="Last ECS Days" body={(rowData: IPOC_Setting) => <p>{rowData.last_ECS_Days}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column field="last_ECI_Days" header="Last ECI Days" body={(rowData: IPOC_Setting) => <p>{rowData.last_ECI_Days}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
                <Column field="last_PO_Days" header="Last PO Days" body={(rowData: IPOC_Setting) => <p>{rowData.last_PO_Days}</p>} editor={(options) => cellEditor(options)} onCellEditComplete={onCellEditComplete} />
            </DataTable>
            <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                <Button loading={loading} disabled={loading} style={{ width: "100px" }} label="SAVE" type="button" onClick={() => {
                    if (tableData.tableData.length > 0) {
                        onsubmit();
                    }
                }} ></Button>
            </div>
        </>
    );
}